import React, {useState, useEffect} from 'react'
import Head from 'next/head'
import {InnerPageHeader} from '@components/InnerPageHeader'
import {VStack} from '@components/Stack'

const AboutPage = () => {
  return (
    <>
      <Head>
        <title key="title">About | CSSBattle</title>
        <meta property="og:title" content="About | CSSBattle" key="ogTitle" />
      </Head>
      <InnerPageHeader
        icon="learn"
        title="About CSSBattle"
        subtitle='"Without CSS there would have been no style"'
      />

      <div
        className="container__item container__item--main new-font"
        style={{borderRight: '0'}}
      >
        <div className="item__content  item__content--inner-page  item__content--fixed-width">
          <VStack align="stretch">
            <VStack align="stretch" gap="0.5rem">
              <p className="">
                CSSBattle is an online CSS{' '}
                <a
                  href="https://en.wikipedia.org/wiki/Code_golf"
                  rel="external"
                >
                  Code Golfing
                </a>{' '}
                game. Here, players from all around the world try to visually
                replicate "Targets" in smallest possible CSS code and battle it
                out to get to the top of the leaderboard.
              </p>
              <p className="">CSSBattle is made by these 2 CSS freaks:</p>
              <div style={{display: 'flex', gap: '2rem', flexWrap: 'wrap'}}>
                <figure className="aboutus-avatar">
                  <img
                    src="/images/avatar-chang.png"
                    height="300"
                    style={{borderRadius: '1rem'}}
                  />
                  <caption>
                    <a href="https://x.com/chinchang457" rel="external">
                      Kushagra Gour
                    </a>
                  </caption>
                </figure>
                <figure className="aboutus-avatar">
                  <img
                    src="/images/avatar-kush.jpg"
                    height="300"
                    style={{borderRadius: '1rem'}}
                  />
                  <caption>
                    <a href="https://x.com/kushsolitary" rel="external">
                      Kushagra Agarwal
                    </a>
                  </caption>
                </figure>
              </div>
            </VStack>
            <VStack gap="0.5rem" align="stretch">
              <h3 className="heading">Some mentions around the Web</h3>
              <p className="">
                <a
                  href="https://www.producthunt.com/posts/cssbattle?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-cssbattle"
                  target="_blank"
                  rel="external noreferrer noopener"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=150383&theme=dark"
                    alt="CSSBattle - Play against others in golf with your CSS skills | Product Hunt Embed"
                    style={{width: '250px', height: '54px'}}
                    width="250px"
                    height="54px"
                  />
                </a>
              </p>
            </VStack>
            <VStack gap="0.5rem" align="stretch">
              <h3 className="heading">Press Kit</h3>
              <p>
                Download our logos, product screenshots, and the press release
                of the product.
              </p>
              <div>
                <a href="/cssbattle-presskit.zip" download className="button">
                  Download Press Kit
                </a>
              </div>
            </VStack>
          </VStack>
        </div>
      </div>
    </>
  )
}

export default AboutPage
